module.exports = __webpack_public_path__ + "5a3df90af37010fab25136017a2eeb99.png";